import * as React from 'react';
import { format } from 'sql-formatter'
import SyntaxHighlighter from 'react-syntax-highlighter';
import { vs } from 'react-syntax-highlighter/dist/esm/styles/hljs';
import { 
  DialogContent,
} from '@mui/material';
import { CDialog, CDialogTitle, CDialogActions, CButton } from '../components/common/Modal';

export default function QueryModal(props) {
  const {open, query, type, handleClose} = props;
  let queryData = query;
  if(type === 'oracle' && query) {
    const { gridDefinition: {pov: {members: pov}, columns, rows} } = JSON.parse(query);
    const columnMembers = columns.map(item => item.members);
    const rowMembers = rows.map(item => item.members);
    queryData = JSON.stringify({pov, columns: columnMembers, rows: rowMembers}, null, 2);
  }

  const formatedSQL = (query) => {
    return format(query);
  }

  return (
    <>
      <CDialog
        open={open}
        onClose={handleClose}
        maxWidth={"md"}
      >
        <CDialogTitle>SQL Query</CDialogTitle>
        <DialogContent>
          <SyntaxHighlighter language='sql' style={vs}>
            {queryData && (type === 'oracle' ? queryData: formatedSQL(queryData))}
          </SyntaxHighlighter>
        </DialogContent>
        <CDialogActions>
          <CButton onClick={handleClose}>Cancel</CButton>
          <CButton onClick={handleClose}>Ok</CButton>
        </CDialogActions>
      </CDialog>
    </>
  )
}